import React, { useCallback, useState } from 'react';
import { Creative } from 'packages/store/creatives/types';
import DesignsBulkExportModal from 'packages/pages/designsBulkExportModal';

const useDesignsBulkExportModal = () => {
    const [bulkExportModalDesigns, setBulkExportModalDesigns] = useState<Creative[]>([]);

    const isOpen = bulkExportModalDesigns.length > 0;

    const handleCloseModal = useCallback(() => {
        setBulkExportModalDesigns([]);
    }, []);

    const renderDesignsBulkExportModal = () => {
        return <DesignsBulkExportModal isOpen={isOpen} designs={bulkExportModalDesigns} onClose={handleCloseModal} />;
    };

    return {
        setBulkExportModalDesigns,
        renderDesignsBulkExportModal,
    };
};

export default useDesignsBulkExportModal;
